import React from 'react';
import { LISTING_TYPES } from 'util/constants';

export const MAX_MOBILE_SCREEN_WIDTH = 1024;

export const hostServiceTypes = [
  {
    key: LISTING_TYPES.PLAYER_PROFILE,
    text: 'Players Community Profile',
    svg: (
      <svg
        width="31"
        height="32"
        viewBox="0 0 31 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M19.9474 4.15789V1V4.15789ZM19.9474 4.15789V7.31579V4.15789ZM19.9474 4.15789H12.8421H19.9474ZM1 13.6316V27.8421C1 29.5862 2.41384 31 4.15789 31H26.2632C28.0073 31 29.4211 29.5862 29.4211 27.8421V13.6316H1Z"
          stroke="#0058FA"
          strokewidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="transparent"
        />
        <path
          d="M1 13.6338V7.31805C1 5.57399 2.41384 4.16016 4.15789 4.16016H7.31579"
          stroke="#0058FA"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="transparent"
        />
        <path
          d="M7.3208 1V7.31579"
          stroke="#0058FA"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="transparent"
        />
        <path
          d="M29.4161 13.6338V7.31805C29.4161 5.57399 28.0023 4.16016 26.2582 4.16016H25.4688"
          stroke="#0058FA"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="transparent"
        />
      </svg>
    ),
  },
  {
    key: LISTING_TYPES.LISTING,
    text: 'Hourly Session',
    svg: (
      <svg
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="transparent"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M16 8V16H24"
          stroke="#0058FA"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="transparent"
        />
        <path
          d="M16 31C24.2842 31 31 24.2842 31 16C31 7.71573 24.2842 1 16 1C7.71573 1 1 7.71573 1 16C1 24.2842 7.71573 31 16 31Z"
          stroke="#0058FA"
          strokeWidth="1.5"
          strokeLinecap="round"
          fill="transparent"
          strokeLinejoin="round"
        />
      </svg>
    ),
  },
  {
    key: LISTING_TYPES.CLASS,
    text: 'Classes',
    svg: (
      <svg
        width="38"
        height="30"
        viewBox="0 0 38 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          x="1"
          y="1"
          width="36"
          height="28"
          rx="4"
          stroke="#0058FA"
          strokeWidth="1.5"
          fill="transparent"
        />
        <path
          d="M24 15L15.75 20.1962L15.75 9.80385L24 15Z"
          stroke="#0058FA"
          strokeWidth="1.5"
          strokeLinejoin="round"
          fill="transparent"
        />
      </svg>
    ),
  },
  {
    key: LISTING_TYPES.PRODUCT,
    text: 'Product',
    svg: (
      <svg
        width="31"
        height="32"
        viewBox="0 0 31 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M19.9474 4.15789V1V4.15789ZM19.9474 4.15789V7.31579V4.15789ZM19.9474 4.15789H12.8421H19.9474ZM1 13.6316V27.8421C1 29.5862 2.41384 31 4.15789 31H26.2632C28.0073 31 29.4211 29.5862 29.4211 27.8421V13.6316H1Z"
          stroke="#0058FA"
          strokewidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="transparent"
        />
        <path
          d="M1 13.6338V7.31805C1 5.57399 2.41384 4.16016 4.15789 4.16016H7.31579"
          stroke="#0058FA"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="transparent"
        />
        <path
          d="M7.3208 1V7.31579"
          stroke="#0058FA"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="transparent"
        />
        <path
          d="M29.4161 13.6338V7.31805C29.4161 5.57399 28.0023 4.16016 26.2582 4.16016H25.4688"
          stroke="#0058FA"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="transparent"
        />
      </svg>
    ),
  },
  {
    key: LISTING_TYPES.FACILITY,
    text: 'Rental Spaces',
    svg: (
      <svg
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="16" cy="16" r="15" stroke="#0058FA" strokeWidth="1.5" fill="transparent" />
        <path
          d="M17.5 16H8.5V18.25M17.5 16C17.5 17.6568 18.8432 19 20.5 19C22.1568 19 23.5 17.6568 23.5 16C23.5 14.3431 22.1568 13 20.5 13C18.8432 13 17.5 14.3431 17.5 16Z"
          stroke="#0058FA"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="transparent"
        />
        <path
          d="M11.5 16V18.25"
          stroke="#0058FA"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="transparent"
        />
      </svg>
    ),
  },
  {
    key: LISTING_TYPES.EVENT,
    text: 'Events',
    svg: (
      <svg
        width="29"
        height="32"
        viewBox="0 0 29 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M28.2353 8.96883V23.0312C28.2353 23.3609 28.0566 23.6646 27.7683 23.8248L15.0586 30.8857C14.7844 31.0381 14.4509 31.0381 14.1767 30.8857L1.46698 23.8248C1.17878 23.6646 1.00003 23.3609 1.00003 23.0312L1 8.96883C1 8.63913 1.17875 8.33535 1.46696 8.17524L14.1767 1.11424C14.4509 0.96192 14.7844 0.96192 15.0586 1.11424L27.7683 8.17524C28.0564 8.33535 28.2353 8.63913 28.2353 8.96883Z"
          stroke="#0058FA"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="transparent"
        />
        <path
          d="M1.79443 8.87938L14.1716 15.7556C14.4458 15.9078 14.7792 15.9078 15.0534 15.7556L27.4736 8.85547"
          stroke="#0058FA"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="transparent"
        />
        <path
          d="M14.6177 29.6176V16"
          stroke="#0058FA"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="transparent"
        />
      </svg>
    ),
  },
];

export const educationServiceType = [
  {
    key: LISTING_TYPES.COURSES,
    text: 'Classes',
    svg: (
      <svg
        width="31"
        height="32"
        viewBox="0 0 31 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M19.9474 4.15789V1V4.15789ZM19.9474 4.15789V7.31579V4.15789ZM19.9474 4.15789H12.8421H19.9474ZM1 13.6316V27.8421C1 29.5862 2.41384 31 4.15789 31H26.2632C28.0073 31 29.4211 29.5862 29.4211 27.8421V13.6316H1Z"
          stroke="#0058FA"
          strokewidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="transparent"
        />
        <path
          d="M1 13.6338V7.31805C1 5.57399 2.41384 4.16016 4.15789 4.16016H7.31579"
          stroke="#0058FA"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="transparent"
        />
        <path
          d="M7.3208 1V7.31579"
          stroke="#0058FA"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="transparent"
        />
        <path
          d="M29.4161 13.6338V7.31805C29.4161 5.57399 28.0023 4.16016 26.2582 4.16016H25.4688"
          stroke="#0058FA"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="transparent"
        />
      </svg>
    ),
  },
  {
    key: LISTING_TYPES.EDUCATION_COURSES,
    text: 'Courses',
    svg: (
      <svg
        width="38"
        height="30"
        viewBox="0 0 38 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          x="1"
          y="1"
          width="36"
          height="28"
          rx="4"
          stroke="#0058FA"
          strokeWidth="1.5"
          fill="transparent"
        />
        <path
          d="M24 15L15.75 20.1962L15.75 9.80385L24 15Z"
          stroke="#0058FA"
          strokeWidth="1.5"
          strokeLinejoin="round"
          fill="transparent"
        />
      </svg>
    ),
  },
  {
    key: LISTING_TYPES.HOURLY_SESSION,
    text: 'Hourly Session',
    svg: (
      <svg
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="transparent"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M16 8V16H24"
          stroke="#0058FA"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="transparent"
        />
        <path
          d="M16 31C24.2842 31 31 24.2842 31 16C31 7.71573 24.2842 1 16 1C7.71573 1 1 7.71573 1 16C1 24.2842 7.71573 31 16 31Z"
          stroke="#0058FA"
          strokeWidth="1.5"
          strokeLinecap="round"
          fill="transparent"
          strokeLinejoin="round"
        />
      </svg>
    ),
  },
];
export const tennisServiceType = [
  {
    key: LISTING_TYPES.PLAYER_PROFILE,
    text: 'Players Community Profile',
    svg: (
      <svg
        width="31"
        height="32"
        viewBox="0 0 31 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M19.9474 4.15789V1V4.15789ZM19.9474 4.15789V7.31579V4.15789ZM19.9474 4.15789H12.8421H19.9474ZM1 13.6316V27.8421C1 29.5862 2.41384 31 4.15789 31H26.2632C28.0073 31 29.4211 29.5862 29.4211 27.8421V13.6316H1Z"
          stroke="#0058FA"
          strokewidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="transparent"
        />
        <path
          d="M1 13.6338V7.31805C1 5.57399 2.41384 4.16016 4.15789 4.16016H7.31579"
          stroke="#0058FA"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="transparent"
        />
        <path
          d="M7.3208 1V7.31579"
          stroke="#0058FA"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="transparent"
        />
        <path
          d="M29.4161 13.6338V7.31805C29.4161 5.57399 28.0023 4.16016 26.2582 4.16016H25.4688"
          stroke="#0058FA"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="transparent"
        />
      </svg>
    ),
  },
  {
    key: LISTING_TYPES.EVENT,
    text: 'Events',
    svg: (
      <svg
        width="29"
        height="32"
        viewBox="0 0 29 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M28.2353 8.96883V23.0312C28.2353 23.3609 28.0566 23.6646 27.7683 23.8248L15.0586 30.8857C14.7844 31.0381 14.4509 31.0381 14.1767 30.8857L1.46698 23.8248C1.17878 23.6646 1.00003 23.3609 1.00003 23.0312L1 8.96883C1 8.63913 1.17875 8.33535 1.46696 8.17524L14.1767 1.11424C14.4509 0.96192 14.7844 0.96192 15.0586 1.11424L27.7683 8.17524C28.0564 8.33535 28.2353 8.63913 28.2353 8.96883Z"
          stroke="#0058FA"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="transparent"
        />
        <path
          d="M1.79443 8.87938L14.1716 15.7556C14.4458 15.9078 14.7792 15.9078 15.0534 15.7556L27.4736 8.85547"
          stroke="#0058FA"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="transparent"
        />
        <path
          d="M14.6177 29.6176V16"
          stroke="#0058FA"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="transparent"
        />
      </svg>
    ),
  },
  {
    key: LISTING_TYPES.PRODUCT,
    text: 'Product',
    svg: (
      <svg
        width="31"
        height="32"
        viewBox="0 0 31 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M19.9474 4.15789V1V4.15789ZM19.9474 4.15789V7.31579V4.15789ZM19.9474 4.15789H12.8421H19.9474ZM1 13.6316V27.8421C1 29.5862 2.41384 31 4.15789 31H26.2632C28.0073 31 29.4211 29.5862 29.4211 27.8421V13.6316H1Z"
          stroke="#0058FA"
          strokewidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="transparent"
        />
        <path
          d="M1 13.6338V7.31805C1 5.57399 2.41384 4.16016 4.15789 4.16016H7.31579"
          stroke="#0058FA"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="transparent"
        />
        <path
          d="M7.3208 1V7.31579"
          stroke="#0058FA"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="transparent"
        />
        <path
          d="M29.4161 13.6338V7.31805C29.4161 5.57399 28.0023 4.16016 26.2582 4.16016H25.4688"
          stroke="#0058FA"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="transparent"
        />
      </svg>
    ),
  },
];

export const hostTypes = [
  {
    key: LISTING_TYPES.PLAYER_PROFILE,
    text: 'Players Community Profile',
    svg: (
      <svg
        width="31"
        height="32"
        viewBox="0 0 31 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M19.9474 4.15789V1V4.15789ZM19.9474 4.15789V7.31579V4.15789ZM19.9474 4.15789H12.8421H19.9474ZM1 13.6316V27.8421C1 29.5862 2.41384 31 4.15789 31H26.2632C28.0073 31 29.4211 29.5862 29.4211 27.8421V13.6316H1Z"
          stroke="#0058FA"
          strokewidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="transparent"
        />
        <path
          d="M1 13.6338V7.31805C1 5.57399 2.41384 4.16016 4.15789 4.16016H7.31579"
          stroke="#0058FA"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="transparent"
        />
        <path
          d="M7.3208 1V7.31579"
          stroke="#0058FA"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="transparent"
        />
        <path
          d="M29.4161 13.6338V7.31805C29.4161 5.57399 28.0023 4.16016 26.2582 4.16016H25.4688"
          stroke="#0058FA"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="transparent"
        />
      </svg>
    ),
  },
  {
    key: LISTING_TYPES.FREELANCER,
    text: `Coach Instructor`,
    svg: (
      <svg
        width="54"
        height="61"
        viewBox="0 0 54 61"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M0 60.6438H38.357L14.5659 36.4834C10.1818 38.7628 6.50249 42.2241 3.93267 46.4866C1.36285 50.7492 0.00207485 55.6478 0 60.6438Z"
          fill="#0058FA"
        />
        <path
          d="M53.5602 60.6465C53.5624 55.6558 52.2079 50.761 49.6455 46.4999C47.0832 42.2389 43.4122 38.7765 39.0359 36.4932L23.8457 45.9323L38.3562 60.6465H53.5602Z"
          fill="#4889FF"
        />
        <path
          d="M40.924 5.93959C37.1767 2.13785 32.0936 0.00131967 26.7929 6.11129e-07C21.4923 -0.00131844 16.4081 2.13269 12.6591 5.93256C8.91 9.73243 6.80306 14.8869 6.80176 20.2621C6.80046 25.6372 8.9049 30.7927 12.6521 34.5945L14.5665 36.4865C18.3583 34.5152 22.5582 33.4871 26.8193 33.4871C31.0803 33.4871 35.2802 34.5152 39.072 36.4865L40.9448 34.5874C44.6867 30.7848 46.7865 25.6311 46.7826 20.2591C46.7787 14.8872 44.6714 9.7366 40.924 5.93959Z"
          fill="#FFB81D"
        />
        <path
          d="M26.7781 33.4883C22.5296 33.4892 18.3425 34.5163 14.5635 36.4846L26.785 48.913L39.0343 36.4917C35.2446 34.5108 31.0416 33.4808 26.7781 33.4883Z"
          fill="#FFB81D"
        />
      </svg>
    ),
  },
  {
    key: LISTING_TYPES.COMPANY,
    text: 'Company',
    svg: (
      <svg
        width="64"
        height="65"
        viewBox="0 0 64 65"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M4.50586 2.07154V60.5958H32.5001V2.07154C32.5001 0.955826 31.5873 0.0429688 30.4716 0.0429688H6.53443C5.41872 0.0429688 4.50586 0.955826 4.50586 2.07154Z"
          fill="#0058FA"
        />
        <path
          d="M32.5 19.2122V60.595H60.4943V19.2122C60.4943 18.0965 59.5814 17.1836 58.4657 17.1836H34.5286C33.4129 17.1836 32.5 18.0965 32.5 19.2122Z"
          fill="#0058FA"
        />
        <path
          d="M9.88147 12.9246H16.17C16.7786 12.9246 17.1843 12.5188 17.1843 11.9103V5.62171C17.1843 5.01314 16.7786 4.60742 16.17 4.60742H9.88147C9.2729 4.60742 8.86719 5.01314 8.86719 5.62171V11.9103C8.86719 12.5188 9.2729 12.9246 9.88147 12.9246ZM20.8358 12.9246H27.1243C27.7329 12.9246 28.1386 12.5188 28.1386 11.9103V5.62171C28.1386 5.01314 27.7329 4.60742 27.1243 4.60742H20.8358C20.2272 4.60742 19.8215 5.01314 19.8215 5.62171V11.9103C19.8215 12.5188 20.3286 12.9246 20.8358 12.9246ZM9.88147 23.7774H16.17C16.7786 23.7774 17.1843 23.3717 17.1843 22.7631V16.4746C17.1843 15.866 16.7786 15.4603 16.17 15.4603H9.88147C9.2729 15.4603 8.86719 15.866 8.86719 16.4746V22.7631C8.86719 23.2703 9.2729 23.7774 9.88147 23.7774ZM20.8358 23.7774H27.1243C27.7329 23.7774 28.1386 23.3717 28.1386 22.7631V16.4746C28.1386 15.866 27.7329 15.4603 27.1243 15.4603H20.8358C20.2272 15.4603 19.8215 15.866 19.8215 16.4746V22.7631C19.8215 23.2703 20.3286 23.7774 20.8358 23.7774ZM9.88147 34.5288H16.17C16.7786 34.5288 17.1843 34.1231 17.1843 33.5146V27.226C17.1843 26.6174 16.7786 26.2117 16.17 26.2117H9.88147C9.2729 26.2117 8.86719 26.6174 8.86719 27.226V33.5146C8.86719 34.1231 9.2729 34.5288 9.88147 34.5288ZM20.8358 34.5288H27.1243C27.7329 34.5288 28.1386 34.1231 28.1386 33.5146V27.226C28.1386 26.6174 27.7329 26.2117 27.1243 26.2117H20.8358C20.2272 26.2117 19.8215 26.6174 19.8215 27.226V33.5146C19.8215 34.1231 20.3286 34.5288 20.8358 34.5288ZM37.8758 32.196H44.1643C44.7729 32.196 45.1786 31.7903 45.1786 31.1817V24.8931C45.1786 24.2846 44.7729 23.8788 44.1643 23.8788H37.8758C37.2672 23.8788 36.8615 24.2846 36.8615 24.8931V31.1817C36.8615 31.7903 37.2672 32.196 37.8758 32.196ZM47.8158 24.8931V31.1817C47.8158 31.7903 48.2215 32.196 48.83 32.196H55.1186C55.7272 32.196 56.1329 31.7903 56.1329 31.1817V24.8931C56.1329 24.2846 55.7272 23.8788 55.1186 23.8788H48.83C48.3229 23.8788 47.8158 24.386 47.8158 24.8931ZM37.8758 43.0489H44.1643C44.7729 43.0489 45.1786 42.6431 45.1786 42.0346V35.746C45.1786 35.1374 44.7729 34.7317 44.1643 34.7317H37.8758C37.2672 34.7317 36.8615 35.1374 36.8615 35.746V42.0346C36.8615 42.5417 37.2672 43.0489 37.8758 43.0489ZM48.83 43.0489H55.1186C55.7272 43.0489 56.1329 42.6431 56.1329 42.0346V35.746C56.1329 35.1374 55.7272 34.7317 55.1186 34.7317H48.83C48.2215 34.7317 47.8158 35.1374 47.8158 35.746V42.0346C47.8158 42.5417 48.3229 43.0489 48.83 43.0489ZM37.8758 53.8003H44.1643C44.7729 53.8003 45.1786 53.3946 45.1786 52.786V46.4974C45.1786 45.8888 44.7729 45.4831 44.1643 45.4831H37.8758C37.2672 45.4831 36.8615 45.8888 36.8615 46.4974V52.786C36.8615 53.3946 37.2672 53.8003 37.8758 53.8003ZM48.83 53.8003H55.1186C55.7272 53.8003 56.1329 53.3946 56.1329 52.786V46.4974C56.1329 45.8888 55.7272 45.4831 55.1186 45.4831H48.83C48.2215 45.4831 47.8158 45.8888 47.8158 46.4974V52.786C47.8158 53.3946 48.3229 53.8003 48.83 53.8003ZM9.88147 45.3817H16.17C16.7786 45.3817 17.1843 44.976 17.1843 44.3674V38.0788C17.1843 37.4703 16.7786 37.0646 16.17 37.0646H9.88147C9.2729 37.0646 8.86719 37.4703 8.86719 38.0788V44.3674C8.86719 44.8746 9.2729 45.3817 9.88147 45.3817ZM20.8358 45.3817H27.1243C27.7329 45.3817 28.1386 44.976 28.1386 44.3674V38.0788C28.1386 37.4703 27.7329 37.0646 27.1243 37.0646H20.8358C20.2272 37.0646 19.8215 37.4703 19.8215 38.0788V44.3674C19.8215 44.8746 20.3286 45.3817 20.8358 45.3817Z"
          fill="#4889FF"
        />
        <path
          d="M13.6348 50.3502V60.5945H23.3719V50.3502C23.3719 49.7417 22.9662 49.3359 22.3576 49.3359H14.6491C14.0405 49.3359 13.6348 49.7417 13.6348 50.3502Z"
          fill="#FFB81D"
        />
        <path
          d="M0.956055 62.6243V64.9571H63.9432V62.6243C63.9432 61.5086 63.0303 60.5957 61.9146 60.5957H2.98463C1.86891 60.5957 0.956055 61.5086 0.956055 62.6243Z"
          fill="#0058FA"
        />
      </svg>
    ),
  },
];

export const educationHostTypes = [
  {
    key: LISTING_TYPES.TUTOR,
    text: 'Tutors',
    svg: (
      <svg
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="transparent"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M16 8V16H24"
          stroke="#0058FA"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="transparent"
        />
        <path
          d="M16 31C24.2842 31 31 24.2842 31 16C31 7.71573 24.2842 1 16 1C7.71573 1 1 7.71573 1 16C1 24.2842 7.71573 31 16 31Z"
          stroke="#0058FA"
          strokeWidth="1.5"
          strokeLinecap="round"
          fill="transparent"
          strokeLinejoin="round"
        />
      </svg>
    ),
  },
  {
    key: LISTING_TYPES.ACADEMY,
    text: 'Academy',
    svg: (
      <svg
        width="31"
        height="32"
        viewBox="0 0 31 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M19.9474 4.15789V1V4.15789ZM19.9474 4.15789V7.31579V4.15789ZM19.9474 4.15789H12.8421H19.9474ZM1 13.6316V27.8421C1 29.5862 2.41384 31 4.15789 31H26.2632C28.0073 31 29.4211 29.5862 29.4211 27.8421V13.6316H1Z"
          stroke="#0058FA"
          strokewidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="transparent"
        />
        <path
          d="M1 13.6338V7.31805C1 5.57399 2.41384 4.16016 4.15789 4.16016H7.31579"
          stroke="#0058FA"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="transparent"
        />
        <path
          d="M7.3208 1V7.31579"
          stroke="#0058FA"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="transparent"
        />
        <path
          d="M29.4161 13.6338V7.31805C29.4161 5.57399 28.0023 4.16016 26.2582 4.16016H25.4688"
          stroke="#0058FA"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="transparent"
        />
      </svg>
    ),
  },
];
export const tennisHostTypes = [
  {
    key: LISTING_TYPES.TUTOR,
    text: 'Tutors',
    svg: (
      <svg
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="transparent"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M16 8V16H24"
          stroke="#0058FA"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="transparent"
        />
        <path
          d="M16 31C24.2842 31 31 24.2842 31 16C31 7.71573 24.2842 1 16 1C7.71573 1 1 7.71573 1 16C1 24.2842 7.71573 31 16 31Z"
          stroke="#0058FA"
          strokeWidth="1.5"
          strokeLinecap="round"
          fill="transparent"
          strokeLinejoin="round"
        />
      </svg>
    ),
  },
  {
    key: LISTING_TYPES.ACADEMY,
    text: 'Academy',
    svg: (
      <svg
        width="31"
        height="32"
        viewBox="0 0 31 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M19.9474 4.15789V1V4.15789ZM19.9474 4.15789V7.31579V4.15789ZM19.9474 4.15789H12.8421H19.9474ZM1 13.6316V27.8421C1 29.5862 2.41384 31 4.15789 31H26.2632C28.0073 31 29.4211 29.5862 29.4211 27.8421V13.6316H1Z"
          stroke="#0058FA"
          strokewidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="transparent"
        />
        <path
          d="M1 13.6338V7.31805C1 5.57399 2.41384 4.16016 4.15789 4.16016H7.31579"
          stroke="#0058FA"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="transparent"
        />
        <path
          d="M7.3208 1V7.31579"
          stroke="#0058FA"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="transparent"
        />
        <path
          d="M29.4161 13.6338V7.31805C29.4161 5.57399 28.0023 4.16016 26.2582 4.16016H25.4688"
          stroke="#0058FA"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="transparent"
        />
      </svg>
    ),
  },
];
export const getImgSource = (key, isEducationSite) => {
  switch (key) {
    case LISTING_TYPES.FREELANCER:
      return 'https://res.cloudinary.com/movementbuddy/image/upload/v1657787540/Rectangle_6870_mieryg.png';

    case LISTING_TYPES.COMPANY:
      return 'https://res.cloudinary.com/movementbuddy/image/upload/v1657787600/Rectangle_6869_k3q7la.png';

    case LISTING_TYPES.LISTING:
    case LISTING_TYPES.PLAYER_PROFILE:
    case LISTING_TYPES.CLASS:
    case LISTING_TYPES.EVENT:
    case LISTING_TYPES.FACILITY:
    case LISTING_TYPES.PRODUCT:
    case LISTING_TYPES.MEMBERSHIP:
      return 'https://res.cloudinary.com/movementbuddy/image/upload/v1657790189/Rectangle_6957_kmgd6q.png';

    default:
      return isEducationSite
        ? 'https://res.cloudinary.com/movementbuddy-pte-ltd/image/upload/v1681883336/probuddy/static/NewEducation/select_type_hjnkaz.png'
        : 'https://res.cloudinary.com/movementbuddy/image/upload/v1657787540/Rectangle_6870_mieryg.png';
  }
};

export const getNewPageName = listingType => {
  switch (listingType) {
    case LISTING_TYPES.COMPANY:
      return 'NewCompanyPage';
    case LISTING_TYPES.FREELANCER:
      return 'NewFreelancerPage';
    case LISTING_TYPES.FACILITY:
      return 'NewFacilityPage';
    case LISTING_TYPES.ENQUIRY:
      return 'NewInquirePage';
    case LISTING_TYPES.CLASS:
      return 'NewClassPage';
    case LISTING_TYPES.EVENT:
      return 'NewEventPage';
    case LISTING_TYPES.PRODUCT:
      return 'NewProductPage';
    case LISTING_TYPES.MEMBERSHIP:
      return 'NewMembershipPage';
    case LISTING_TYPES.ACADEMY:
      return 'NewAcademyPage';
    case LISTING_TYPES.TUTOR:
      return 'NewTutorPage';
    case LISTING_TYPES.COURSES:
      return 'NewCoursesPage';
    case LISTING_TYPES.EDUCATION_COURSES:
      return 'NewEducationCoursesPage';
    case LISTING_TYPES.HOURLY_SESSION:
      return 'NewHourlySessionPage';
    case LISTING_TYPES.REMOTE_TUTOR:
      return 'NewRemoteTutor';
    case LISTING_TYPES.PLAYER_PROFILE:
      return 'NewPlayerProfilePage';
    case LISTING_TYPES.LISTING:
    default:
      return 'NewListingPage';
  }
};
